export const CONSTANTS = {
  APP_NAME: 'Comfort - The Home Craft',
  SHARE_URL: 'https://comfort---the-home-craft.pages.dev',
}
